

import { Time } from '@angular/common';
import { Observable } from 'rxjs';
import { Parameter } from '../common/parameter';
import * as TimeSpan from 'timespan';

export interface CertificateParameter extends Parameter {
    searchTerm: number;
    orderBy: string;

}

export interface PatientCertificate {
    id?: any;
    tenantId: any;
    branchId: any;
    regId: any;
    requestedDate: Date;
    certificateId: any;
    issueDate: Date;
    certificateDets?: CertificateDet;
    params: any;
    text?: string;

    parameters?: CertificateParameter[];
    links?: any;
}

export interface CertificateMst {
    certificateId?: any;
    tenantId: any;
    branchId: any;
    certificateType: string;
    certificateTitle: string;
    certificateDescription: string;
    certificateDetailMsts?: CertificateDet[];
    
}

export interface CertificateDet {
    cfId: any;
    certificateId: any;
    certificateFields? : CertificateFields
}

export interface CertificateFields {
    cfId: any;
    cfName: any;
    tblName: string;
    columnName: string;
    
}


export abstract class CertificateData {
    abstract getById(url: string): Observable<any>;
    abstract list(url: string): Observable<any[]>;
    abstract create(url: string, data: any): Observable<any>;
    //abstract bulkUpdate(url: string, data: CertificateMst[]): Observable<CertificateMst>;
    abstract update(url: string, data: CertificateMst): Observable<CertificateMst>;
    abstract delete(url: string): Observable<any>;
}